export default __webpack_public_path__ + "static/media/manometr.5a84a39e.png";